import { Component, Input, OnInit, ViewChild, signal } from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';
import { NgxDynamicDashboardModule } from '@mare-common/ngx-dynamic-dashboard';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { CurrencyFormatterPipe } from 'src/app/shared/pipes/currency-formatter.pipe';
import { ChartBuilderService } from 'src/app/services/chart-builder.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'src/environments/environment';
import { MatCardModule } from '@angular/material/card';
import { PlotlyViaWindowModule } from 'angular-plotly.js';
import {Subject, Subscription } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { Router } from '@angular/router';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { CompanyFinancialStatements, UserCompanyService } from 'src/app/services/userCompany.service';
import { ComponentIdentityReportComponent } from '../component-identity-report/component-identity-report.component';
import { LandingService } from 'src/app/services/landing.service';
import { CompanyDataErrorComponent } from '../company-data-error/company-data-error.component';
import { fadInRight, fadeInLeftAnimation, pulse } from 'src/app/shared/animations/animations';
import { DownloadAnimationDirective } from 'src/app/shared/directives/download-animation.directive';

export enum losses_profits {
	losses = "subito perdite",
	profits = "fatto un utile",
}
@Component({
	selector: 'app-dashboard-overview',
	standalone: true,
	imports: [CommonModule,
		NgxDynamicDashboardModule,
		TranslateModule,
		MatButtonModule,
		MatChipsModule,
		MatIconModule,
		MatCardModule,
		SharedModule,
		PlotlyViaWindowModule,
		ComponentIdentityReportComponent,
		CompanyDataErrorComponent,
		DownloadAnimationDirective,
	],
	animations: [
		pulse,
		fadInRight,
		fadeInLeftAnimation
	],
	templateUrl: './dashboard-overview.component.html',
	styleUrls: ['./dashboard-overview.component.scss']
})
export class DashboardOverviewComponent implements OnInit {
	@Input() user: any;
	@Input() company: any;
	@Input() layout: 'a' | 'b' = 'a';
	@Input() downloadReportDirectly: boolean = true;
	@Input() reportMode: 'modal' | 'page' | 'buttons' = 'buttons';
	@Input() showPlansButton: boolean = false;

	companyEureso: any;
	companyPiva: any;

	missingFinancials$ = signal<boolean>(false);
	companyAnalizingErrors$ = signal<string[]>([]);
	downloading$ = signal(false);

	@ViewChild('plotbar') plotbar!: PlotlyViaWindowModule;
	// private _plot!: PlotlyComponent;
	overviewready$ = signal(false);
	fatturatoAzienda: any;
	profitsValueDiff!: any;
	mycompany: string = "La tua azienda";
	graphicDataOverview: any;

	assetPrefixUrl = environment.assetsPrefixUrl;
	currencyPipe = new CurrencyFormatterPipe();
	fatturatoMedioMercato!: number;
	averageProfits: any;
	errorMessage!: { type: string; message: string; };
	lostProfits: any;
	ebitda: any;
	profittabilitaMercato: any;
	utilePerso: any;
	utileAziendaInveceDi: any;
	profittabilitaAzienda: any;
	potentialProfittabilityMediaMercato: any;
	potentialProfittabilityAzienda: any;
	lossesOrProfits: losses_profits = losses_profits.profits;// if true company is loosing earnings
	lostProfitsValues: any;
	ebitdaAbs!: number;
	private unsubscribe$ = new Subject<void>();
	downloadState: any;
	downloadReportObserver = {
		next: (value: any) => {
			this.downloadState = value ?? null;
		},
		error: (error: any) => {
			console.error(error)
		},
		complete: () => {
			this.downloadState = null
		}
	}

	myReportReadyOrAvailable$ = signal(false)
	clickOnAcquistaButton: 'report' | 'paypal' | 'cart' = 'cart';
	// reportBundle: any;
	reportSubscription: Subscription = new Subscription();
	visibilityState: { [key: string]: boolean } = {};
	constructor(private chartBuilderService: ChartBuilderService,
		private viewportScroller: ViewportScroller,
		// private dialog: MatDialog,
		private reportService: ReportService,
		// private cartService: CartService,
		private router: Router,
		private commonConfig: CommonConfig,
		private userCompanyService: UserCompanyService,
		private landingService: LandingService
		// private chartConfigService: ChartConfigService,
		// private productService:ProductService
	) {
		this.clickOnAcquistaButton = this.commonConfig.getFromConfig('clickOnAcquistaButton', 'cart');
		if (!this.clickOnAcquistaButton) {
			this.clickOnAcquistaButton = 'cart';
		}
	}

	ngOnInit(): void {
		this.initOverview();
		console.log(this.company);
		
		

		// this.productService.getProducts().then((res: any) => {
		// 	console.log('_____________get all products____________',res);
		// })

		/**
		 * recuperiamo il prodotto Benchmark per mostrare i dettagli nella modale
		 * ma solo se siamo nel layout 'b'
		 *  */ 
		
		// if (this.downloadReportDirectly) {
		// 	this.reportService.getReportBundle().then((res: any) => {
		// 		// nel res abbiamo reportDigitale->prodotto e reportPlans->varianti
		// 		this.reportBundle = res.reportDigitale;
		// 	})
		// }

		// this.reportSubscription = this.reportService.getRequestedObservable().subscribe({
		// 	  next: (data) => {
		// 			// let report = data;
		// 			this.manageRequestes(data);
		// 			console.log('reportService.getRequestedObservable', data);
		//   },
		// 	  error: (error) => {
		// 		console.error('Error fetching report:', error);
		// 	  },
		// 	  complete: () => {
		// 		console.log('Report fetching complete');
		// 	  }
		// 	});
		  

		// this.reportService.downloadState$.pipe(
		// 	takeUntil(this.unsubscribe$)
		// ).subscribe((res) => {
		// 	console.log('reportService.downloadState', res);
		// });
		

		// this.reportService.getRequested().then((sub: any) => {
		// 	sub.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
		// 		// find element in res that has status 'requested' or 'started'
		// 		console.log('reportService.getRequested', res);
		// 		if (res?.payload && Object.keys(res?.payload).length > 0) {
		// 			// loop over object.keys(res?.payload) and fint the first element that has status 'requested' or 'started'
		// 			// if found, set downloadState to that element

		// 			let found: any = Object.keys(res?.payload).find(key => res?.payload[key].status === 'started' || res?.payload[key].status === 'requested');
		// 			if (found) {
		// 				// check if is expired request by checking if requestDate is older than one hour
		// 				if (res.payload[found].requestTimestamp < new Date().getTime() - 3600000 && (res.payload[found].status === 'started' || res.payload[found].status === 'requested')) {
		// 					this.downloadReportObserver.next(false);
		// 				} else {
		// 					this.downloadReportObserver.next(res?.payload[found]);
		// 				}
		// 			}
		// 			let foundMyReport = Object.keys(res?.payload).some(key => res?.payload[key].status === 'completed' && key === this.companyEureso?.alternateSummary?.vatRegistrationNumber);
		// 			if (foundMyReport || this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests) > 0) {
		// 				this.myReportReadyOrAvailable$.set(true)
		// 			}
		// 		} else if(this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests)>0) {
		// 			this.myReportReadyOrAvailable$.set(true)
		// 		}
		// 		// console.log(res);
		// 	})
		// });
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.reportSubscription?.unsubscribe();
	}

	onViewportChange(elementId: string, isInViewport: boolean) {
		if(!Object.keys(this.visibilityState).includes(elementId) && !this.visibilityState[elementId] && isInViewport) {
			this.visibilityState[elementId] = true;
		}
	  }


	manageRequestes(data?: any) {
		if (data) {
			// let found: any = Object.keys(data).find(key => data[key].status === 'started' || data[key].status === 'requested');
			// if (found) {
			// 	// check if is expired request by checking if requestDate is older than one hour
			// 	if (data[found].requestTimestamp < new Date().getTime() - 3600000 && (data[found].status === 'started' || data[found].status === 'requested')) {
			// 		this.downloadReportObserver.next(false);
			// 	} else {
			// 		this.downloadReportObserver.next(data[found]);
			// 	}
			// }
			let foundMyReport = Object.keys(data).some(key => data[key].status === 'completed' && key === this.companyEureso?.alternateSummary?.vatRegistrationNumber);
			if (foundMyReport || this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests) > 0) {
				this.myReportReadyOrAvailable$.set(true)
			}
		}else if(this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests)>0) {
			this.myReportReadyOrAvailable$.set(true)
		}
	}

	

	initOverview() {
		this.landingService.getDashboard().then((res: any) => {
			this.company = res?.company;
			if (!this.company) {
				this.missingFinancials$.set(true);
				this.companyAnalizingErrors$.set(['Dati azienda mancanti']);
				return;
			}
			this.companyEureso = this.company.eureso_overview;
			if(!this.companyEureso || !this.companyEureso?.localFinancialStatements || this.companyEureso?.localFinancialStatements?.length === 0) {
				this.missingFinancials$.set(true);
				this.companyAnalizingErrors$.set(['Dati finanziari mancanti']);
				return;
			}
			this.companyPiva = this.company.eureso_overview.alternateSummary?.vatRegistrationNumber
			// let fatturatoAzienda = company_eureso.localFinancialStatements.find((item: any) => item.yeardEndDataLatest ;
			let latestStatement=this.companyEureso.localFinancialStatements.sort((a:any,b:any) => new Date(b.yearEndDate).getTime() - new Date(a.yearEndDate).getTime())[0];
			let fatturatoAzienda = latestStatement.profitAndLoss.totalValueOfProduction;;
			let ebitda = latestStatement.profitAndLoss.ebitda;
			let profittabilitaAzienda = (ebitda / fatturatoAzienda) * 100;
			let istat = res.istat;
			let fatturatoMedioMercato = istat?.fatturato_medio_settore?.media_fatturato ?? 0;
			let molMedio = istat?.fatturato_medio_settore?.media_mol ?? 0;
			
			let profittabilitaMercato = molMedio !== 0  && fatturatoMedioMercato !== 0 ? (molMedio / fatturatoMedioMercato) * 100 : 0;
          	let utilePerso = fatturatoAzienda && profittabilitaMercato ? (fatturatoAzienda * profittabilitaMercato / 100 ) - ebitda : 0;
			let companyFinancialStatements: any = {
				ebitda: ebitda,
				fatturatoAzienda: fatturatoAzienda,
				fatturatoMedio: fatturatoMedioMercato ,
				profittabilitaAzienda: profittabilitaAzienda,
				profittabilitaMercato: profittabilitaMercato,
				utilePerso: utilePerso
			};
			this.buildCompanyGraphData(companyFinancialStatements).then((_res) => {
				if (_res) {
					const interval = setTimeout(() => {
						if (this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests) > 0) {
							this.graphicDataOverview.graphic.data[0].x = _res;
						}else{
							this.graphicDataOverview.graphic.data[0].y = _res;
						}
						clearTimeout(interval);
					}, 500);
				}
			}).catch((err) => {
				this.errorMessage = err;
			}).finally(() => {
				this.overviewready$.set(true);
				if(this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests)>0) {
					this.myReportReadyOrAvailable$.set(true)
				}
				
				
			})

		})

		// old method to retrieve chart data from marker
		// this.userCompanyService.buildCompanyProfitsLossData().then((res: CompanyFinancialStatements) => {
		// 	console.log(res);
			
		// 	if (res) {
		// 		this.buildCompanyGraphData(res).then((_res) => {
		// 			if (_res) {
		// 				const interval = setTimeout(() => {
		// 					if (this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests) > 0) {
		// 						this.graphicDataOverview.graphic.data[0].x = _res;
		// 					}else{
		// 						this.graphicDataOverview.graphic.data[0].y = _res;
		// 					}
		// 					clearTimeout(interval);
		// 				}, 500);
		// 			}
		// 		}).catch((err) => {
		// 			this.errorMessage = err;
		// 		}).finally(() => {
		// 			this.overviewready$.set(true);
		// 		});
		// 	}
		// }).catch((err) => {
		// 	this.errorMessage = err;
		// 	console.log(err);
		// });


	}

	buildCompanyGraphData(data:CompanyFinancialStatements):Promise<any> {
		return new Promise((resolve, reject) => {
			this.mycompany = this.companyEureso.companySummary.businessName
			this.fatturatoAzienda = data.fatturatoAzienda
			this.ebitda = data.ebitda;
			this.profittabilitaAzienda = data.profittabilitaAzienda;
			this.profittabilitaMercato = data.profittabilitaMercato;
			this.ebitdaAbs = Math.abs(this.ebitda);
			this.potentialProfittabilityAzienda = this.fatturatoAzienda * this.profittabilitaMercato / 100
			this.utilePerso = data.utilePerso;

			this.profitsValueDiff = this.profittabilitaAzienda && this.profittabilitaMercato ? ((this.profittabilitaAzienda / this.profittabilitaMercato - 1) * 100).toFixed(2) : 0;
			this.profitsValueDiff = Math.abs(this.profitsValueDiff);
			console.log(this.profittabilitaAzienda, this.profittabilitaMercato);
			this.lostProfitsValues = [
				{
					id: "ros",
					rosfor: " Azienda",
					value: 0

				},
				{
					id: "costs",
					rosfor: "Media di mercato",
					value: 0

				}]
			let diffvalue = this.fatturatoAzienda - this.fatturatoMedioMercato
			// if (diffvalue < 0) {
			this.lossesOrProfits = this.ebitda > 0 ? losses_profits.profits : losses_profits.losses;
			// }
			this.lostProfits = this.currencyPipe.transform(diffvalue, 'EUR');
			// this.graphicDataOverview = this.buildRosChart(this.lostProfitsValues, this.lostProfits, [Math.min(this.profittabilitaAzienda, this.profittabilitaMercato) > 0 ? 0 : Math.min(this.profittabilitaAzienda, this.profittabilitaMercato), Math.max(this.profittabilitaAzienda, this.profittabilitaMercato)]);
			let gdo;
			if (this.company?.delfi_report_max_requests && Number(this.company?.delfi_report_max_requests) > 0) {
				// grafico verticale prima del benchamrk
				gdo = this.buildRosChartCondensed(this.lostProfitsValues, this.lostProfits, [Math.min(this.profittabilitaAzienda, this.profittabilitaMercato) > 0 ? 0 : Math.min(this.profittabilitaAzienda, this.profittabilitaMercato), Math.max(this.profittabilitaAzienda, this.profittabilitaMercato)]);
				let x = gdo.graphic.data[0].x;
				let y = gdo.graphic.data[0].y;

				gdo.graphic.data[0].x = y;
				gdo.graphic.data[0].y = x;
			} else {
				gdo = this.buildRosChart(this.lostProfitsValues, this.lostProfits, [Math.min(this.profittabilitaAzienda, this.profittabilitaMercato) > 0 ? 0 : Math.min(this.profittabilitaAzienda, this.profittabilitaMercato), Math.max(this.profittabilitaAzienda, this.profittabilitaMercato)]);
				//grafico orizzontale dopo acquisto del benchamrk
			}
			this.graphicDataOverview = gdo;
			console.log('this.graphicDataOverview',this.graphicDataOverview);
			this.overviewready$.set(true);
			resolve([this.profittabilitaAzienda, this.profittabilitaMercato])
		});
		
	}

	buildRosChartCondensed(values: Array<any>, lossProfists: number | string, range?: Array<any>) {

		let earnLoose = (lossProfists as string).indexOf('-') > -1 ? 'Mancato guadagno' : 'Guadagno';
		let trendColors = (lossProfists as string).indexOf('-') > -1 ? ['#08AAB7', '#071d52'] : ['#071d52', '#08AAB7'];

		let objValues: { ros: { id: string; rosfor: string; value: number; }[] } = {
			ros: []
		}
		for (const val of values) {
			objValues.ros.push({ id: val.id, rosfor: val.rosfor, value: val.value })
		}

		let _graphicDataOverview: any = this.chartBuilderService.buildChart('ros', 'BAR', '', '', 'ros', 'rosfor', 'value', objValues, '', '170', '200', '%');
		if (_graphicDataOverview.graphic.data?.length > 0) {
			// _graphicDataOverview.graphic.data[0].hole = 0.6;
			_graphicDataOverview.graphic.data[0].marker.color = trendColors;
			_graphicDataOverview.graphic.data[0].textposition = 'inside';
			_graphicDataOverview.graphic.data[0].insidetextfont = {size:16}
			// format texttemplate to convert value into millions, miles or billions
			_graphicDataOverview.graphic.data[0].texttemplate = '%{label}: %{value:.2f}%';//[this.profittabilitaAzienda.toFixed(2), this.profittabilitaMercato.toFixed(2)]; //'%{value:.2f}€';
			_graphicDataOverview.graphic.data[0].hoverinfo = 'none';//
			 _graphicDataOverview.graphic.data[0].height = [0.8, 0.8]
			// _graphicDataOverview.graphic.data[0].yAxis = {
			// 	autorange: false,
			// 	range: [Math.min(values[0], values[1]), Math.max(values[0], values[1]) + 1],
			// }
			_graphicDataOverview.graphic.data[0].orientation= 'h'
		}
		_graphicDataOverview.graphic.layout.margin = { t:16, b:16, l:8, r:8 };
		// _graphicDataOverview.graphic.layout.automargin = true;
		_graphicDataOverview.graphic.layout.showlegend = false;
		_graphicDataOverview.graphic.layout.paper_bgcolor = 'rgba(0,0,0,0)';
		_graphicDataOverview.graphic.layout.plot_bgcolor = 'rgba(0,0,0,0)';
		_graphicDataOverview.graphic.layout.font = {
			color: '#ffffff', size: 14,
			family: '"Pt Sans Narrow","Open Sans", verdana, arial, sans-serif'
		};
		_graphicDataOverview.graphic.layout.yaxis = {showticklabels : false, fixedrange: true };


		// _graphicDataOverview.graphic.layout.yaxis = { range: range ?? [-10, 10] },
		_graphicDataOverview.graphic.layout.xaxis = {
			range: range ?? [-10, 10],
			fixedrange: true,
			showticklabels: false
		 },

		_graphicDataOverview.graphic.layout.transition = {
			duration: 1000,
			easing: 'easeIn',
		}
		_graphicDataOverview.graphic.layout.frame = {
			duration: 500
		}

		let config = {
			displayModeBar: false,
			modeBarButtonsToRemove: ['toImage'],
			displaylogo: false,
			dragMode: false,
			scrollZoom: false
		}
		_graphicDataOverview.graphic.config = config;
		return _graphicDataOverview;

	}


	buildRosChart(values: Array<any>, lossProfists: number | string, range?: Array<any>) {

		let earnLoose = (lossProfists as string).indexOf('-') > -1 ? 'Mancato guadagno' : 'Guadagno';
		let trendColors = (lossProfists as string).indexOf('-') > -1 ? ['#08AAB7', '#0025ff'] : ['#0025ff', '#08AAB7'];

		let objValues: { ros: { id: string; rosfor: string; value: number; }[] } = {
			ros: []
		}
		for (const val of values) {
			objValues.ros.push({ id: val.id, rosfor: val.rosfor, value: val.value })
		}

		let _graphicDataOverview: any = this.chartBuilderService.buildChart('ros', 'BAR', '', '', 'ros', 'rosfor', 'value', objValues, '', '400', '500', '%');
		if (_graphicDataOverview.graphic.data?.length > 0) {
			// _graphicDataOverview.graphic.data[0].hole = 0.6;
			_graphicDataOverview.graphic.data[0].marker.color = trendColors;
			_graphicDataOverview.graphic.data[0].textposition = 'inside';
			_graphicDataOverview.graphic.data[0].insidetextfont = {size:32}
			// format texttemplate to convert value into millions, miles or billions
			_graphicDataOverview.graphic.data[0].texttemplate = '%{value:.2f}%';//[this.profittabilitaAzienda.toFixed(2), this.profittabilitaMercato.toFixed(2)]; //'%{value:.2f}€';
			_graphicDataOverview.graphic.data[0].hoverinfo = 'none';//
			_graphicDataOverview.graphic.data[0].width = [0.6, 0.6]
			// _graphicDataOverview.graphic.data[0].yAxis = {
			// 	autorange: false,
			// 	range: [Math.min(values[0], values[1]), Math.max(values[0], values[1]) + 1],
			// }
			// _graphicDataOverview.graphic.data[0].orientation= 'h'
		}
		_graphicDataOverview.graphic.layout.margin = { t: 24, b: 24, l: 24, r: 24 };
		// _graphicDataOverview.graphic.layout.automargin = true;
		_graphicDataOverview.graphic.layout.showlegend = false;
		_graphicDataOverview.graphic.layout.paper_bgcolor = 'rgba(0,0,0,0)';
		_graphicDataOverview.graphic.layout.plot_bgcolor = 'rgba(0,0,0,0)';
		_graphicDataOverview.graphic.layout.font = {
			color: '#ffffff', size: 14,
			family: '"Pt Sans Narrow","Open Sans", verdana, arial, sans-serif'
		};

		_graphicDataOverview.graphic.layout.yaxis = {
			range: range ?? [-10, 10],
			fixedrange: true
		},

		_graphicDataOverview.graphic.layout.xaxis = {
			fixedrange: true
		},

		_graphicDataOverview.graphic.layout.transition = {
			duration: 1000,
			easing: 'easeIn',
		}
		_graphicDataOverview.graphic.layout.frame = {
			duration: 500
		}

		let config = {
			displayModeBar: false,
			modeBarButtonsToRemove: ['toImage'],
			displaylogo: false,
			dragMode: false,
			scrollZoom :false,
		}
		_graphicDataOverview.graphic.config = config;

		return _graphicDataOverview;

	}

	scrollToElement(elementId: string): void {
		this.viewportScroller.scrollToAnchor(elementId);
	}

	/**
	 * 
	 * configurazione per aprire la modale del report delegta al report service
	 */
	getReportModal() {
		// this._getReportModal(this.companyEureso.alternateSummary.vatRegistrationNumber);
		this.reportService.getReportModal(this.companyEureso.alternateSummary.vatRegistrationNumber, 'report_free');
	}
	
	goToReport(forcedownload: boolean = false) {
		if (forcedownload) {
			this.downloading$.set(true);
			this.reportService.downloadReport(this.companyPiva).then(() => {
				this.downloading$.set(false);
			}).finally(() => {
				this.downloading$.set(false);
			});
		} else {
			let basePath = environment.routingBasePath;
			this.router.navigate([basePath + '/selfcaring'], { fragment: 'benchmark' })
		}

	}

	/**
	 * Downloads a report as a PDF file or in new browser tab.
	 *
	 * If the report is not ready, it will request the report generation and retry the download after 5 seconds.
	 * If the report is ready, it will download the report.
	 *
	 * @return {Promise<boolean | { payload: 'started' | 'done' | 'completed' | 'error' }>} A promise that resolves to true if the download is successful or an object with the status of the report generation.
	 */
	downloadReport() {
		this.downloading$.set(true);
		this.landingService.downloadReport(this.companyPiva, !this.myReportReadyOrAvailable$() ? 'light' : undefined)
			.then((res: boolean | { payload: 'started' | 'done' | 'completed' | 'error' }) => {
				if (typeof res !== 'boolean' && res.payload === 'started') {
					setTimeout(() => this.downloadReport(), 5000);
				} else if (typeof res === 'boolean') {
					console.log('downloaded');
					this.downloading$.set(false)
				}
				else {
					this.downloading$.set(false);
					if(res.payload === 'error') {
						console.error('Error downloading report: ', res);
					}
				}
			})
			.catch((err: any) => {
				this.downloading$.set(false);
				console.log(err);
			});
	}

}
